import * as React from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import constantsStorage from 'constants/Storage';
import AppContext from 'contexts/AppContext';
import useChangeAuthData from 'types/hooks/useChangeAuthData';
import AuthData from 'types/models/AuthData';
import useChangeVenue from './useChangeVenue';

export default (): useChangeAuthData => {
  const { setAuthData } = React.useContext(AppContext);
  const { deleteCurrentVenue } = useChangeVenue()
  const storeAuthData = async (authData: AuthData): Promise<void> => {
    try {
      await AsyncStorage.setItem(constantsStorage.authData, JSON.stringify(authData));
      setAuthData(authData);
    } catch (error) {
      console.log(error);
    }
  };
  const deleteAuthData = async (): Promise<void> => {
    try {
      await AsyncStorage.removeItem(constantsStorage.authData);
      setAuthData(null);
      await deleteCurrentVenue();
    } catch (error) {
      console.log(error);
    }
  };
  return { storeAuthData, deleteAuthData };
};
